<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'ReadButton',

    functional: true,

    props: {
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        disabled: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            label: props.label || parent.$t('common.actions.read'),
            iconClass: 'fa fa-eye',
            color: 'btn-info',
            isSmall: props.isSmall,
            hideLabel: props.hideLabel,
            disabled: props.disabled,
        };

        return createElement(BaseButton, data);
    },
};
</script>
